export class PrefijoModel{
	
	constructor(public valorCampo1:string,
		public valorCampo2:string,
		public valorCampo3:string,
		public valorCampo4:string,
		public valorCampo5:string,
		public cprefijo:string, 
		public ndiasvenc:number,
		public tipoPrefijo:number ){
	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearFactura/Prefijo.model.ts